// extracted by css-extract-rspack-plugin
var _1 = "pJuzI";
var _2 = "t28Ow";
export { _1 as "outerContainer", _2 as "swipeableContentContainer" }
